export { HasAccessForPlatformQuery } from './has-access-for-platform';
export { GetJivositeInfo } from './get-jivosite-info';
